import { render, staticRenderFns } from "./SearchAuthor.vue?vue&type=template&id=3f5b7b80"
import script from "./SearchAuthor.vue?vue&type=script&lang=js"
export * from "./SearchAuthor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports